import { BrowserRouter, useLocation } from "react-router-dom";
import AuthProvider from "./context/AuthContext";
import AppRouter from "./routes/AppRouter";
import NavBar from "./components/NavBar/NavBar";
import EmailSignup from "./components/EmailSignup/EmailSignup";
import Footer from "./components/Footer/Footer";
import "normalize.css";
import "./App.css";

const AppContent = () => {
  const location = useLocation();

  const emailSignupRoutes = [
    "/",
    "/about",
    "/aftercare",
  ];

  const showEmailSignup = emailSignupRoutes.includes(location.pathname);

  return (
    <>
      <NavBar />
      <AppRouter />
      {showEmailSignup && <EmailSignup />}
      <Footer />
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;